module.exports = __webpack_public_path__ + "2c8fdcb76bbd4c6ecf8325e4384df1ba.png";


//////////////////
// WEBPACK FOOTER
// ../images/publisher/profile/yes-inactive.png
// module id = 1063
// module chunks = 69